"use client";
import { createContext, useContext } from "react";
import { DEFAULT_LAYOUT, type LayoutId } from "@/lib/layouts";

/**
 * Modelul de aspect, rezolvat pe SERVER (om → firmă → implicit) și livrat clientului.
 * AppShell citește de aici ca să aleagă structura: bară de module sus (Tablou) sau rail
 * vertical (Consolă / Cifra). Pe server și pe client valoarea e ACEEAȘI, deci hidratarea
 * nu are ce să contrazică — spre deosebire de o citire din `document` sau din localStorage.
 */
const LayoutContext = createContext<LayoutId>(DEFAULT_LAYOUT);

export function UiLayoutProvider({ layout, children }: { layout: LayoutId; children: React.ReactNode }) {
  return <LayoutContext.Provider value={layout}>{children}</LayoutContext.Provider>;
}

export function useUiLayout(): LayoutId {
  return useContext(LayoutContext);
}
